import styled from '@emotion/styled'
import { Card } from '@material-ui/core'
import { Button } from 'ui-components/Button'

export const Container = styled(Card)`
  display: grid;
  grid-template-columns: 120px auto 80px;
  column-gap: 20px;
  padding: 10px 20px 0;
  margin-top: 10px;
`

export const SelectContainer = styled.div`
  padding-top: 10px;
`

export const AddButton = styled(Button)`
  margin-top: 10px;
  height: 40px;
`
